import React from 'react';
import { Box } from 'shared/components/display';

const ToolbarDivider: React.FC = () => {
  return <Box as="span" className="richtext-tool-bar__divider" />;
};

export default ToolbarDivider;
